<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <form class="element-box"
            @submit.prevent="guardar"
            >
              <router-link
                class="btn btn-sm btn-outline-info"
                :to="{ name: 'cat-cupones-apl-nuevo' }"
              >
                <i class="fas fa-angle-double-left"></i>
                Regresar
              </router-link>
              <h5 class="form-header">
                <h5 v-if="!current.id">
                  Asignar precio cupon APL &nbsp;
                  <i class="fas fa-plus fa-lg text-success"></i>
                </h5>
                <h5 v-if="current.id">
                  Asignar Precio cupon APL
                  <span
                    class="badge"
                    v-bind:class="{
                      'badge-success': current.estatus == true,
                      'badge-danger': current.estatus == false,
                    }"
                    ><div v-if="current.estatus == true">ACTIVO</div>
                    <div v-if="current.estatus == false">INACTIVO</div></span
                  >
                  &nbsp;&nbsp;
                  <button @click="abrirModalEstatics" type="button" class="btn btn-primary btn-md">
                    <i class="fas fa-chart-line"></i> &nbsp;Mostrar Estadisticas
                  </button>
                </h5>

                &nbsp;
                <div class="element-actions">
                  <div class="btn-group">
                    <button
                      :disabled="!current.id"
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown"
                      type="button"
                    >
                      <i class="fa fa-cogs"></i>
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        @click="dar_de_baja()"
                        class="dropdown-item"
                        type="button"
                        :disabled="current.estatus == false"
                      >
                        <i class="fas fa-user"></i><i class="fas fa-times"></i>
                        &nbsp; Dar de baja
                      </button>
                      <div class="dropdown-divider"></div>
                    </div>
                  </div>
                </div>
              </h5>
              <div class="row">
                <div class="col-3">
                  <label>CUI de beneficiario</label>
                  <input
                    :disabled="current.id"
                    type="text"
                    v-model="current.identificacion"
                    class="form-control"
                  />
                </div>
                <div class="col-3">
                  <label>Nombre de beneficiario</label>
                  <input type="text" v-model="current.nombre" class="form-control" />
                </div>
                <div class="col-3">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.tienda,
                    }"
                    >Tipo oferta</label
                  >
                  <select
                    :disabled="current.estatus == false"
                    class="form-control"
                    v-model="current.tipo_oferta"
                  >
                    <option selected value="I">INTERNO</option>
                    <option value="E">EXTERNO</option>
                  </select>
                  <small
                    v-if="current.errors && current.errors.tipo_oferta"
                    class="form-text text-danger"
                    >{{ current.errors.tipo_oferta[0] }}</small
                  >
                  <br />
                </div>
                <div class="col-3">
                  <label>Fecha inicio</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="current.fecha_inicio"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.fecha_inicio"
                    >{{ current.errors.fecha_inicio }}</small
                  >
                </div>
                <div class="col-2">
                  <label>Fecha fin</label>
                  <input
                    :disabled="current.estatus == false"
                    type="date"
                    class="form-control"
                    v-model="current.fecha_fin"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.fecha_fin"
                    >{{ current.errors.fecha_fin }}</small
                  >
                  <br />
                </div>
                <div class="col-2">
                  <label>Cant. maxima de usos</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="current.max_cant_usos"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.max_cant_usos"
                    >{{ current.errors.max_cant_usos[0] }}</small
                  >
                </div>
                <div class="col-2">
                  <label>Cant. de veces usado</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="current.cantidad_usos"
                    :disabled="true"
                  />
                </div>
                <div class="col-2">
                  <label>Usuario</label>
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    v-model="current.usuario_obj.username"
                  />
                </div>
                <div class="col-4">
                  <ListasPrecioSelectComponent :current="current" />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.lista_precio"
                    >{{ current.errors.lista_precio[0] }}</small
                  >
                  <br />
                </div>
              </div>
              <div class="form-buttons-w">
                <button
                  :disabled="current.estatus == false"
                  class="btn btn-md btn-success"
                  type="submit"
                >
                  <i class="fas fa-save"></i> Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="ModalAplCupon"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-xl" role="document" style="max-width: 100%">
        <div class="modal-content modal-xl" style="max-width: 100%">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">
              Estadísticas de uso &nbsp;&nbsp;
              <i class="fas fa-chart-line fa-2x text-success"></i>
            </h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
              <!-------------------- Tabla de REsultados -------------------->
              <table class="table table-lightborder table-hover">
                <thead>
                  <tr>
                    <th class="text-center">cant tickets</th>
                    <th class="text-center">Tiempo de uso</th>
                    <th class="text-center">min gastado</th>
                    <th class="text-center">max gastado</th>
                    <th class="text-center">Ticket promedio</th>
                    <th class="text-center">gasto promedio mensual</th>
                    <th class="text-center">Total comprado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="det in dataTabla" v-bind:key="det.id">
                    <td class="text-center">
                      {{ det.cant_tickets }}
                    </td>
                    <td class="text-center">{{ det.meses }} Meses</td>
                    <td class="text-center">Q {{ det.min_ticket_gastado_GTQ }}</td>
                    <td class="text-center">Q {{ det.max_ticket_gastado_GTQ }}</td>
                    <td class="text-center">Q {{ det.ticket_promedio_GTQ }}</td>
                    <td class="text-center">Q {{ det.gasto_promedio_mensual_GTQ }}</td>
                    <td class="text-center">Q {{ det.total_comprado_GTQ }}</td>
                  </tr>
                </tbody>
              </table>
              <!-------------------- END - Basic Table -------------------->
            </div>
            <hr />
            <div class="table-responsive" style="overflow-y: scroll; max-height: 300px">
              <!-------------------- Tabla de REsultados -------------------->
              <table class="table table-lightborder table-hover">
                <thead>
                  <tr>
                    <th class="text-center">Número</th>
                    <th class="text-center">Tienda</th>
                    <th class="text-center">Fecha creación</th>
                    <th class="text-right">Valor total</th>
                    <th class="text-center">forma de pago</th>
                    <th class="text-center">Nombre de tienda</th>
                    <th class="text-right">Total pagado</th>
                    <th class="text-right"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="det in dataTablaLista"
                    v-bind:key="det.id"
                    style="font-size: 15px"
                  >
                    <td class="text-center">
                      <span>{{ det.numero }}</span>
                    </td>
                    <td class="text-center">
                      {{ det.nombre_tienda }}
                    </td>
                    <td class="text-center">
                      {{ det.fecha_creacion | moment("DD/MM/YYYY HH:mm:ss") }}
                    </td>
                    <td class="text-right">Q. {{ det.valor_total.toFixed(2) }}</td>
                    <td class="text-center">
                      {{ det.forma_pago_id }}
                    </td>
                    <td class="text-center">
                      {{ det.nombre_tienda }}
                    </td>
                    <td class="text-right">Q. {{ det.total_pagado.toFixed(2) }}</td>
                    <td class="text-right">
                      <router-link
                        :to="{
                          name: 'cxc-cargos-editar',
                          params: { id: det.cargo_e_id },
                        }"
                        target="_blank"
                        class="btn btn-success btn-sm"
                      >
                        <i class="fas fa-eye"></i>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-------------------- END - Basic Table -------------------->
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              <i class="fas fa-door-open"></i> Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import ListasPrecioSelectComponent from "@/components/commons/ListasPrecioSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    TiendaSelectComponent,
    UsuariosSelectComponent,
    ListasPrecioSelectComponent,
  },
  data() {
    return {
      estatus: false,
      tarea_tipo: "",
      current: {
        identificacion: null,
        tipo_oferta: "I",
        estado: "A",
        estatus: true,
        fecha: "",
        fecha_inicio: "",
        fecha_fin: "",
        usuario_obj: "",
        errors: null
      },
      dataTablaLista: [],
      errors: {
        identificacion: "",
      },
      dataTabla: [],
      detalle: {},
      tipos_liq: [],
      tiendas: [],
      currentDetalle: {},
      tiendas: "",
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent();
      self.refreshListaComprasAPL();
    }
  },
  methods: {
    refreshestadistica() {
      let self = this;
      DynamicService.getAction(
        "cat",
        "lista-precio-cupon",
        this.$route.params.id,
        "promedio_uso_por_colaborador"
      ).then((response) => {
        self.dataTabla = response.data;
        console.log(self.dataTabla);
      });
    },

    refreshListaComprasAPL() {
      let self = this;
      DynamicService.getAction(
        "cat",
        "lista-precio-cupon",
        this.$route.params.id,
        "lista_de_compras_apl_cupon"
      ).then((response) => {
        self.dataTablaLista = response.data;
        console.log(self.dataTabla);
      });
    },
    abrirModalEstatics() {
      let self = this;
      $("#ModalAplCupon").modal("toggle");
      self.refreshestadistica();
    },
    dar_de_baja() {
      let self = this;
      Notifications.alert.confirm(
        "¿Esta seguro que desea darle de baja?",
        "",
        "",
        function () {
          DynamicService.postAction(
            "cat",
            "lista-precio-cupon",
            self.current.id,
            "dar_de_baja"
          )
            .then((response) => {
              Notifications.alert.success(
                "Dar de baja lista precio cupón",
                "Realizado exitosamente"
              );
              self.refreshCurrent();
            })
            .catch((errors) => {
              self.current.errors = errors.response.data;
            });
        }
      );
    },
    guardar() {
      let self = this;
      let _current = Object.assign({}, self.current)
      if (_current.identificacion == '' || !_current.identificacion){
        Notifications.alert.error("Lista Precio Cupón", "Ingrese un Identificador válido");
      }
      if (_current.fecha_fin) {
        _current.fecha_fin = moment(_current.fecha_fin).format("DD/MM/YYYY");
      }
      if (_current.fecha_inicio) {
        _current.fecha_inicio = moment(_current.fecha_inicio).format(
          "DD/MM/YYYY"
        );
      }
      if (_current.lista_precio) {
        _current.lista_precio = _current.lista_precio.id;
      }
      DynamicService.save("cat", "lista-precio-cupon", _current)
        .then((response) => {
          Notifications.alert.success("Lista Precio Cupón", "Agregado existosamente");
          self.$router.push({
            name: "cat-cupones-apl-editar",
            params: { id: response.data.id },
          });
          self.refreshCurrent();
        })
        .catch((errors) => {
          self.current.errors = errors.response.data;
        });
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("cat", "lista-precio-cupon", this.$route.params.id).then(
        (response) => {
          self.current = response.data;
          self.current.fecha_inicio = moment(
            response.data.fecha_inicio,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
          self.current.fecha_fin = moment(self.current.fecha_fin, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          );
          self.current.estado = "B";
          self.estatus = true;
        }
      );
    },
  },
};
</script>
